"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PivotTableDescriptor = void 0;
var tslib_1 = require("tslib");
// (C) 2021 GoodData Corporation
var sdk_model_1 = require("@gooddata/sdk-model");
var PluggablePivotTable_1 = require("./PluggablePivotTable");
var BaseChartDescriptor_1 = require("../baseChart/BaseChartDescriptor");
var drillDownUtil_1 = require("../drillDownUtil");
var PivotTableDescriptor = /** @class */ (function (_super) {
    tslib_1.__extends(PivotTableDescriptor, _super);
    function PivotTableDescriptor() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PivotTableDescriptor.prototype.getFactory = function () {
        return function (params) { return new PluggablePivotTable_1.PluggablePivotTable(params); };
    };
    PivotTableDescriptor.prototype.getSizeInfo = function (_insight, layoutDescriptor, settings) {
        return {
            width: {
                default: layoutDescriptor.gridColumnsCount,
                min: 3,
                max: layoutDescriptor.gridColumnsCount,
            },
            height: {
                default: this.getDefaultHeight(settings.enableKDWidgetCustomHeight),
                min: this.getMinHeight(settings.enableKDWidgetCustomHeight),
                max: this.getMaxHeight(settings.enableKDWidgetCustomHeight),
            },
        };
    };
    PivotTableDescriptor.prototype.applyDrillDown = function (insight, drillDownContext) {
        var drillDownInsight = drillDownUtil_1.modifyBucketsAttributesForDrillDown(insight, drillDownContext.drillDefinition);
        var drillDownInsightWithFilters = drillDownUtil_1.addIntersectionFiltersToInsight(drillDownInsight, drillDownContext.event.drillContext.intersection);
        return drillDownUtil_1.sanitizeTableProperties(sdk_model_1.insightSanitize(drillDownInsightWithFilters));
    };
    return PivotTableDescriptor;
}(BaseChartDescriptor_1.BaseChartDescriptor));
exports.PivotTableDescriptor = PivotTableDescriptor;
//# sourceMappingURL=PivotTableDescriptor.js.map